import { FC } from 'react';
import { useParams } from 'react-router-dom';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import PageSection from 'components/PageSection';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import Spacing from 'components/Spacing';
import { Typography } from '@mui/material';
import { UnrealisedCashFXGainOrLossTypeLabels } from 'further-ui/labels';
import { numberToCurrencyString } from 'further-ui/utils';
import FieldRow from 'components/FormElements/FieldRow';
import RecordView from 'components/RecordView';
import PageLoader from 'components/PageLoader';

const CashHistoryDetail: FC = () => {
  const { recordId } = useParams<{ recordId: string }>();
  const { vehicle } = useLayoutContext();

  const { data: currentRecord, isLoading } =
    api.unrealisedCashFxGainOrLoss.getById.useQuery({
      vehicleId: vehicle?._id ?? '',
      recordId,
    });

  if (isLoading || !vehicle) {
    return <PageLoader />;
  }

  if (!currentRecord) {
    return (
      <PageContainer heading="Unrealised Cash FX Gain/Loss Details">
        <PageContent withSpacing>
          <Typography>Record not found</Typography>
        </PageContent>
      </PageContainer>
    );
  }

  return (
    <PageContainer heading="Unrealised Cash FX Gain/Loss Details">
      <PageContent withSpacing>
        <PageSection title="Details" withSpacing>
          <Spacing>
            <RecordView>
              <FieldRow title="Ledger Date">
                <Typography variant="body2">
                  {currentRecord.ledgerDate.toLabel()}
                </Typography>
              </FieldRow>
              <FieldRow title="Bank Account">
                <Typography variant="body2">
                  {currentRecord.bankAccountName ?? '-'}
                </Typography>
              </FieldRow>
              <FieldRow title="Type">
                <Typography variant="body2">
                  {
                    UnrealisedCashFXGainOrLossTypeLabels[
                      currentRecord.gainOrLossType
                    ]
                  }
                </Typography>
              </FieldRow>
              <FieldRow title="Amount (LCY)">
                <Typography variant="body2">
                  {numberToCurrencyString(currentRecord.amountLcy, {
                    currency: vehicle.baseCurrency,
                    negativeInBrackets: true,
                  })}
                </Typography>
              </FieldRow>
              <FieldRow title="Currency">
                <Typography variant="body2">
                  {currentRecord.currencyCode}
                </Typography>
              </FieldRow>
              {currentRecord.reconciliationId && (
                <FieldRow title="Reconciliation">
                  <Typography variant="body2">Yes</Typography>
                </FieldRow>
              )}
            </RecordView>
          </Spacing>
        </PageSection>
      </PageContent>
    </PageContainer>
  );
};

export default CashHistoryDetail;
